import type { JSX, ReactNode } from "react";
import { StatusChip } from "../../Common";
export interface AnalyticChartPanelProps {
  readonly title: string;
  readonly hint: ReactNode;
  readonly children: ReactNode;
  readonly scopeCaption: ReactNode;
  readonly morphBadge?: string | null;
  readonly legend?: ReactNode;
}
export function AnalyticChartPanel({
  title,
  hint,
  children,
  scopeCaption,
  morphBadge,
  legend,
}: AnalyticChartPanelProps): JSX.Element {
  return (
    <section className="analyticChartPanel">
      <header className="chartHead">
        <h2 className="chartTitle">{title}</h2>
        <p className="chartHint">{hint}</p>
      </header>
      <div className="chartBody">{children}</div>
      <footer className="chartFoot">
        <span className="scopeCaption">{scopeCaption}</span>
        {morphBadge && <StatusChip tone="neutral" size="sm" className="badge morph">{morphBadge}</StatusChip>}
      </footer>
      {legend}
      <style>{`.analyticChartPanel{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius-panel);padding:16px 20px;display:flex;flex-direction:column;flex:1;color:var(--text)}.chartTitle{font-size:18px;font-weight:600;margin:0}.chartHint{font-size:13px;color:var(--text-muted);margin:6px 0}.chartBody{min-height:360px;flex:1;position:relative}.chartFoot{display:flex;gap:12px;flex-wrap:wrap;margin-top:12px;font-size:12px;color:var(--text-muted)}`}</style>
    </section>
  );
}
